import { useMutation } from '@apollo/client'
import { AdminAPI, GraphQL } from '@guestgoodie/graphql'
import { useCallback } from 'react'

export function useSync(type: GraphQL.SyncableObject) {
  const [sync, { loading }] = useMutation(AdminAPI.pms.SYNC)

  const syncType = useCallback(() => {
    sync({
      variables: {
        type
      }
    })
  }, [sync, type])

  return {
    sync: syncType,
    loading
  }
}
